import React, {useState} from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import {MAIN_QUICK_ACTIONS} from '../constants';
import {aiAssistantToggleMainActionUrlField} from "../../../../../redux/slices/lomavisCreator/lomavisCreator";
import {InfoIconWithToolTip} from "../../include/InfoIconWithToolTip";
import {advancedAiTokensAvailable} from "../utils/tokens";
import LomavisUpgradeSubscriptionPageLink from "../../../../billing/utils/openSubscriptionPageLink";


interface Props {
    t: (key: string) => string;
    dispatch: any;
    availableTokens: number;
    usedTokens: number; // if needed
    url: string;
    advancedDataButton: boolean;
}

const CreatePostUrlAction: React.FC<Props> = ({
                                                  t,
                                                  dispatch,
                                                  availableTokens,
                                                  usedTokens,
                                                  url,
    advancedDataButton = false
                                              }) => {
    const CREATE_POST_URL_ACTION = MAIN_QUICK_ACTIONS.find(
        (item) => item.action === 'createPostUrl'
    );

    const onButtonClick = () => {
        if (!advancedAiTokensAvailable(usedTokens, availableTokens)) {
            return;
        }

        dispatch(
            aiAssistantToggleMainActionUrlField()
        )
    }


    // Card inner content re-used in both cases:
    const cardContent = (
        <>
            <div className="btn btn-secondary  btn-sm cursor-pointer"
                 style={{whiteSpace: "nowrap", backgroundImage: "linear-gradient(90deg, rgb(37, 117, 252), rgb(106, 17, 203))"}}
                 onClick={onButtonClick}>
                <div className="d-flex flex-row align-items-center">
                    <div className="d-flex align-items-center">
                        <i className={`${CREATE_POST_URL_ACTION?.icon} me-2 w-20px text-white`}/>
                    </div>
                    <div className="d-flex align-items-center text-white">
                        {t(CREATE_POST_URL_ACTION?.name)}
                    </div>
                    <div className="d-flex align-items-center ps-2 text-white">
                        <InfoIconWithToolTip text={t("lomavisCreator.ai.quickActionFromUrl.rewriteText")}
                                             placement={"top"}
                                             showTokens={true}
                                             availableTokens={availableTokens}
                                                usedTokens={usedTokens}
                                             advancedDataButton={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );

    // If not enough tokens, wrap the entire card in the overlay.
    return !advancedAiTokensAvailable(usedTokens, availableTokens) ? (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip id="tooltip-no-tokens">
                    <div className={"text-start"}>
                        {t('lomavis.branding.mainActions.noTokensTooltip')}
                    </div>
                    <div className={"d-flex justify-content-end"}>
                        <LomavisUpgradeSubscriptionPageLink />
                    </div>
                </Tooltip>
            }
        >
            <div
                key={CREATE_POST_URL_ACTION?.id}
                className={""}
                // Prevent click action when tokens are not available.
                onClick={(e) => {
                    e.preventDefault();
                }}
            >
                {cardContent}
            </div>
        </OverlayTrigger>
    ) : (
        <div
            key={CREATE_POST_URL_ACTION?.id}

            // onClick={handleCreatePostUrlClick}
        >
            {cardContent}
        </div>
    );
};

export default CreatePostUrlAction;
